import React from 'react';
import styled from 'styled-components';
import Wallpaper from './Wallpaper';
import TopPanel from './TopPanel';
import Dock from './Dock';
import DesktopIcons from './DesktopIcons';
import WindowManager from '../WindowManager/WindowManager';
import ContextMenu from './ContextMenu';
import DesktopWidgets from './DesktopWidgets';

const DesktopContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  user-select: none;
`;

const DesktopEnvironment: React.FC = () => {
  return (
    <DesktopContainer>
      <Wallpaper />
      <TopPanel />
      <DesktopIcons />
      <DesktopWidgets />
      <WindowManager />
      <Dock />
      <ContextMenu />
    </DesktopContainer>
  );
};

export default DesktopEnvironment;
